import React, { useState, useEffect, useRef, useId } from "react";
import {
  CarouselContainer,
  SlideContainer,
  Slide,
  Image,
} from "./CustomCarouselStyles";

const CustomCarousel = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const slideRef = useRef();

  const id = useId();

  useEffect(() => {
    const autoPlay = setInterval(() => {
      nextSlide();
    }, 5000);

    return () => {
      clearInterval(autoPlay);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleTouchStart = (e) => {
    slideRef.current.touchStartX = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    const touchEndX = e.changedTouches[0].clientX;
    const touchStartX = slideRef.current.touchStartX;
    const differenceX = touchStartX - touchEndX;

    if (differenceX > 100) {
      nextSlide();
    } else if (differenceX < -100) {
      prevSlide();
    }
  };

  return (
    <CarouselContainer>
      <SlideContainer
        ref={slideRef}
        currentIndex={currentIndex}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
      >
        {images.map((item, index) => (
          <Slide key={`${id}-${index}`}>
            <a href={item.LINK} target="_blank" rel="noopener noreferrer">
              <Image src={item.IMAGEN} alt={`Imagen ${index}`} />
            </a>
          </Slide>
        ))}
      </SlideContainer>
    </CarouselContainer>
  );
};

export default CustomCarousel;